<section class="family-plan-settings" *ngIf="enabled" aria-labelledby="family-plan-settings-title">
  <h4 id="family-plan-settings-title" class="family-plan-settings__title">Family Plan Settings</h4>

  <div class="family-plan-settings__field">
    <label class="family-plan-settings__label" for="familyMaxVehicles"
      >No of Vehicles Allowed<span class="required">*</span></label
    >
    <mat-select
      id="familyMaxVehicles"
      class="form-select"
      placeholder="Select number of vehicles"
      [ngModel]="draft.maxVehicles"
      (ngModelChange)="onMaxVehiclesChange($event)"
      [disabled]="isInteractionDisabled"
    >
      <mat-option *ngFor="let count of vehicleOptions" [value]="count">{{ count }}</mat-option>
    </mat-select>
  </div>

  <div class="family-plan-settings__field">
    <p class="family-plan-settings__label">
      Allowed Discounts for Additional Vehicles<span class="required">*</span>
    </p>
    <div class="family-plan-settings__types" role="radiogroup">
      <label
        class="family-plan-settings__type"
        *ngFor="let type of discountTypes"
        [class.family-plan-settings__type--selected]="draft.discountType === type.value"
      >
        <input
          type="radio"
          name="familyDiscountType"
          class="family-plan-settings__radio"
          [checked]="draft.discountType === type.value"
          [disabled]="isInteractionDisabled"
          (change)="onDiscountTypeChange(type.value)"
        />
        <span class="family-plan-settings__type-text">
          <span class="family-plan-settings__type-label">{{ type.label }}</span>
          <span class="family-plan-settings__hint">{{ type.hint }}</span>
        </span>
      </label>
    </div>
  </div>

  <ng-container *ngIf="draft.discountType">
    <mat-chip-listbox
      class="family-plan-settings__chips"
      multiple
      aria-label="Discount values"
      [disabled]="isInteractionDisabled"
      [value]="draft.values"
      (change)="onChipsChange($event.value)"
    >
      <mat-chip-option
        class="family-plan-settings__chip"
        *ngFor="let chip of chips; trackBy: trackChip"
        [value]="chip.value"
        [removable]="chip.removable"
        [disabled]="!chip.selected && isAtPresetLimit"
        (removed)="onChipRemove(chip)"
      >
        {{ label(chip.value) }}
        <button
          matChipRemove
          *ngIf="chip.removable"
          type="button"
          [attr.aria-label]="'Remove ' + label(chip.value)"
        >
          <span aria-hidden="true">✕</span>
        </button>
      </mat-chip-option>
    </mat-chip-listbox>

    <div class="family-plan-settings__add">
      <span class="family-plan-settings__affix" *ngIf="draft.discountType === 'flat'">$</span>
      <input
        type="text"
        inputmode="decimal"
        class="family-plan-settings__input"
        placeholder="Custom offer"
        aria-label="Custom offer"
        [attr.aria-invalid]="addError ? 'true' : null"
        [attr.aria-describedby]="addError ? 'familyAddError' : null"
        [(ngModel)]="customInput"
        (ngModelChange)="onCustomInputChange()"
        (keydown.enter)="onAddCustom()"
        [disabled]="isInteractionDisabled"
      />
      <span class="family-plan-settings__affix" *ngIf="draft.discountType === 'percentage'">%</span>
      <button
        type="button"
        class="family-plan-settings__add-btn"
        [disabled]="!canAddCustom"
        (click)="onAddCustom()"
      >
        Add option
      </button>
    </div>
    <p id="familyAddError" class="family-plan-settings__error" role="alert" *ngIf="addError">
      {{ addError }}
    </p>
    <p class="family-plan-settings__hint">{{ valueHint }}</p>

    <label class="family-plan-settings__check">
      <input
        type="checkbox"
        class="family-plan-settings__checkbox"
        [checked]="draft.customEnabled"
        [disabled]="isInteractionDisabled"
        (change)="onCustomEnabledChange($any($event.target).checked)"
      />
      <span class="family-plan-settings__check-text">
        <span class="family-plan-settings__type-label">Allow custom discount</span>
        <span class="family-plan-settings__hint"
          >Attendants can enter their own discount at the lane.</span
        >
      </span>
    </label>

    <div class="family-plan-settings__field family-plan-settings__field--half">
      <label class="family-plan-settings__label" for="familyDefaultDiscount"
        >Default discount<span class="required">*</span></label
      >
      <mat-select
        id="familyDefaultDiscount"
        class="form-select"
        placeholder="Select default discount"
        [ngModel]="draft.defaultValue"
        (ngModelChange)="onDefaultChange($event)"
        [disabled]="isInteractionDisabled || draft.values.length === 0"
      >
        <mat-option *ngFor="let value of draft.values" [value]="value">{{
          label(value)
        }}</mat-option>
      </mat-select>
    </div>
  </ng-container>

  <p class="family-plan-settings__error" role="alert" *ngIf="formError">{{ formError }}</p>
</section>
